import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import css from 'classnames'
import { observer } from 'mobx-react-lite'
import { Props } from './types'
import { NavigationLink } from '../nav-link'
import { useStore } from '~/app/store'
import { useCurrentLegalEntityStores } from '~/shared/lib/hooks/use-current-legal-entity-stores'

export const SubMenuItem = observer(({ expanded, items }: Props) => {
  const { t } = useTranslation()
  const { warehousesStore } = useStore()
  const stores = useCurrentLegalEntityStores()

  return (
    <motion.div
      animate={expanded ? { height: 'fit-content' } : { height: 0 }}
      className="overflow-hidden z-[999]"
    >
      {items.map((item) => (
        <div
          key={item.link}
          className="relative group rounded transition-colors hover:bg-gray-100"
        >
          <NavigationLink
            text={
              item.link === '/stores' && stores.length === 1
                ? t('settings')
                : t(item.localeTextName)
            }
            link={item.link}
            isOpen={expanded}
            badgeContent={
              item.badgeKey
                ? warehousesStore.getStatusCount(item.badgeKey)
                : undefined
            }
            badgeIndicator={item.indicatorKey}
            className="pl-[53px] bg-transparent hover:bg-transparent"
            activeClass="bg-gray-200"
          />

          <span
            className={css(
              'w-[3px] h-4 rounded-md bg-blue-600 absolute left-0 top-4 opacity-0 group-hover:opacity-100 transition-all',
            )}
          />
        </div>
      ))}
    </motion.div>
  )
})
